var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagebreak-prevent ui-area"},[_c('div',{staticClass:"px-5 py-5 rounded-md w-fit flex flex-col mx-5 my-5 overflow-hidden",class:_vm.bg},[_c('div',{class:_vm.innerclass},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }